export const styleSelect = {
  control: (styles, { isFocused, isDisabled }) => ({
    ...styles,
    fontSize: "14px !important",
    borderRadius: "0.4rem !important",
    boxShadow: isFocused ? "0 1px 10px 0 rgba(34, 41, 47, 0.1)" : null,
    borderColor: isFocused
      ? "var(--thema-select-focus-border-color) !important"
      : "rgb(217, 214, 211) !important",
    backgroundColor: isDisabled ? "rgb(233, 236, 239)" : "transparent",
    // minHeight: "34px", // 🔥 Altura real do select
  }),

  option: (styles, { isDisabled, isSelected, isFocused }) => ({
    ...styles,

    cursor: isDisabled ? "not-allowed" : "default",
    color: isDisabled
      ? "rgba(0, 0, 0, 0.5) !important"
      : isSelected
      ? "var(--thema-select-selecao-color) !important"
      : isFocused
      ? "var(--thema-select-focus-color) !important"
      : undefined,
    backgroundColor: isSelected
      ? "var(--thema-select-selecao-background) !important"
      : isFocused
      ? "var(--thema-select-focus-background) !important"
      : undefined,
  }),
};

//Em teste-- quero fazer o estilo dark e light!
export function styleDarkSelect(width) {
  return {
    control: (styles, { isFocused, isDisabled }) => ({
      ...styles,
      width: width || undefined,
      fontSize: "14px !important",
      borderRadius: "0rem !important",
      boxShadow: isFocused ? "0 1px 10px 0 rgba(34, 41, 47, 0.1)" : null,
      borderColor: isFocused
        ? "var(--thema-select-focus-border-color) !important"
        : "rgb(217, 214, 211) !important",

      color: "var(--thema-dark-background)",
      backgroundColor: isDisabled
        ? "rgb(233, 236, 239)"
        : "var(--thema-dark-color)",
    }),

    option: (styles, { isDisabled, isSelected, isFocused }) => ({
      ...styles,
      cursor: isDisabled ? "not-allowed" : "default",

      color: isDisabled
        ? "rgba(0, 0, 0, 0.5) !important"
        : isSelected
        ? "var(--thema-dark-color)  !important"
        : isFocused
        ? "var(--thema-dark-background)"
        : "var(--thema-dark-color)",

      backgroundColor: isSelected
        ? "var(--thema-dark-background)"
        : isFocused
        ? "var(--thema-dark-color)"
        : "var(--thema-dark-background)",
    }),
  };
}
